module.exports = __webpack_public_path__ + "img/kecheng.f029ddaa.png";